import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trigger", "nativeTriggerButton", "openOnHover", "delay", "closeDelay", "title", "description", "children", "onClose", "open", "defaultOpen", "handle", "onOpenChange", "side", "align", "sideOffset", "initialFocus", "anchor", "id", "ariaLabel", "ariaLabelledby", "ariaDescribedby", "ariaDescription", "dataTestId", "xstyle"];
import { c as _c } from "react-compiler-runtime";
import { forwardRef, cloneElement } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import { PopoverRoot, PopoverClose, PopoverContent, PopoverDescription, PopoverTitle, PopoverTrigger } from './primitives';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function PopoverInner(t0, ref) {
  var _id, _ariaLabel, _ariaLabelledby, _ariaDescribedby, _ariaDescription, _dataTestId, _ariaDescribedby2, _ariaDescription2, _ariaLabel2, _ariaLabelledby2, _dataTestId2, _id2;
  const $ = _c(59);
  let T0;
  let align;
  let anchor;
  let ariaDescribedby;
  let ariaDescription;
  let ariaLabel;
  let ariaLabelledby;
  let children;
  let dataTestId;
  let description;
  let id;
  let initialFocus;
  let onClose;
  let side;
  let sideOffset;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let title;
  if ($[0] !== ref || $[1] !== t0) {
    const {
        trigger,
        nativeTriggerButton,
        openOnHover,
        delay,
        closeDelay,
        title: t6,
        description: t7,
        children: t8,
        onClose: t9,
        open,
        defaultOpen,
        handle,
        onOpenChange,
        side: t10,
        align: t11,
        sideOffset: t12,
        initialFocus: t13,
        anchor: t14,
        id: t15,
        ariaLabel: t16,
        ariaLabelledby: t17,
        ariaDescribedby: t18,
        ariaDescription: t19,
        dataTestId: t20
      } = t0,
      restProps = _objectWithoutPropertiesLoose(t0, _excluded);
    title = t6;
    description = t7;
    children = t8;
    onClose = t9;
    side = t10;
    align = t11;
    sideOffset = t12;
    initialFocus = t13;
    anchor = t14;
    id = t15;
    ariaLabel = t16;
    ariaLabelledby = t17;
    ariaDescribedby = t18;
    ariaDescription = t19;
    dataTestId = t20;
    T0 = PopoverRoot;
    t1 = defaultOpen;
    t2 = handle;
    t3 = onOpenChange;
    t4 = open;
    t5 = trigger != null && /*#__PURE__*/_jsx(PopoverTrigger, {
      ref: ref,
      closeDelay: closeDelay,
      delay: delay,
      nativeButton: nativeTriggerButton,
      openOnHover: openOnHover,
      render: /*#__PURE__*/cloneElement(trigger, restProps)
    });
    $[0] = ref;
    $[1] = t0;
    $[2] = T0;
    $[3] = align;
    $[4] = anchor;
    $[5] = ariaDescribedby;
    $[6] = ariaDescription;
    $[7] = ariaLabel;
    $[8] = ariaLabelledby;
    $[9] = children;
    $[10] = dataTestId;
    $[11] = description;
    $[12] = id;
    $[13] = initialFocus;
    $[14] = onClose;
    $[15] = side;
    $[16] = sideOffset;
    $[17] = t1;
    $[18] = t2;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = title;
  } else {
    T0 = $[2];
    align = $[3];
    anchor = $[4];
    ariaDescribedby = $[5];
    ariaDescription = $[6];
    ariaLabel = $[7];
    ariaLabelledby = $[8];
    children = $[9];
    dataTestId = $[10];
    description = $[11];
    id = $[12];
    initialFocus = $[13];
    onClose = $[14];
    side = $[15];
    sideOffset = $[16];
    t1 = $[17];
    t2 = $[18];
    t3 = $[19];
    t4 = $[20];
    t5 = $[21];
    title = $[22];
  }
  const t6 = (_id = id) === null || _id === void 0 ? void 0 : _id.root;
  const t7 = (_ariaLabel = ariaLabel) === null || _ariaLabel === void 0 ? void 0 : _ariaLabel.root;
  const t8 = (_ariaLabelledby = ariaLabelledby) === null || _ariaLabelledby === void 0 ? void 0 : _ariaLabelledby.root;
  const t9 = (_ariaDescribedby = ariaDescribedby) === null || _ariaDescribedby === void 0 ? void 0 : _ariaDescribedby.root;
  const t10 = (_ariaDescription = ariaDescription) === null || _ariaDescription === void 0 ? void 0 : _ariaDescription.root;
  const t11 = (_dataTestId = dataTestId) === null || _dataTestId === void 0 ? void 0 : _dataTestId.root;
  let t12;
  if ($[23] !== title) {
    t12 = title != null && /*#__PURE__*/_jsx(PopoverTitle, {
      children: title
    });
    $[23] = title;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== description) {
    t13 = description != null && /*#__PURE__*/_jsx(PopoverDescription, {
      children: description
    });
    $[25] = description;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== ((_ariaDescribedby2 = ariaDescribedby) === null || _ariaDescribedby2 === void 0 ? void 0 : _ariaDescribedby2.closeButton) || $[28] !== ((_ariaDescription2 = ariaDescription) === null || _ariaDescription2 === void 0 ? void 0 : _ariaDescription2.closeButton) || $[29] !== ((_ariaLabel2 = ariaLabel) === null || _ariaLabel2 === void 0 ? void 0 : _ariaLabel2.closeButton) || $[30] !== ((_ariaLabelledby2 = ariaLabelledby) === null || _ariaLabelledby2 === void 0 ? void 0 : _ariaLabelledby2.closeButton) || $[31] !== ((_dataTestId2 = dataTestId) === null || _dataTestId2 === void 0 ? void 0 : _dataTestId2.closeButton) || $[32] !== ((_id2 = id) === null || _id2 === void 0 ? void 0 : _id2.closeButton) || $[33] !== onClose) {
    var _ariaLabel3, _id3, _ariaLabelledby3, _ariaDescribedby3, _ariaDescription3, _dataTestId3, _ariaDescribedby4, _ariaDescription4, _ariaLabel4, _ariaLabelledby4, _dataTestId4, _id4;
    t14 = onClose != null && /*#__PURE__*/_jsx(PopoverClose, {
      onClick: onClose,
      "aria-label": (_ariaLabel3 = ariaLabel) === null || _ariaLabel3 === void 0 ? void 0 : _ariaLabel3.closeButton,
      id: (_id3 = id) === null || _id3 === void 0 ? void 0 : _id3.closeButton,
      "aria-labelledby": (_ariaLabelledby3 = ariaLabelledby) === null || _ariaLabelledby3 === void 0 ? void 0 : _ariaLabelledby3.closeButton,
      "aria-describedby": (_ariaDescribedby3 = ariaDescribedby) === null || _ariaDescribedby3 === void 0 ? void 0 : _ariaDescribedby3.closeButton,
      "aria-description": (_ariaDescription3 = ariaDescription) === null || _ariaDescription3 === void 0 ? void 0 : _ariaDescription3.closeButton,
      "data-test-id": (_dataTestId3 = dataTestId) === null || _dataTestId3 === void 0 ? void 0 : _dataTestId3.closeButton,
      children: unescapedText("trellis-components.popover.closeButton.label")
    });
    $[27] = (_ariaDescribedby4 = ariaDescribedby) === null || _ariaDescribedby4 === void 0 ? void 0 : _ariaDescribedby4.closeButton;
    $[28] = (_ariaDescription4 = ariaDescription) === null || _ariaDescription4 === void 0 ? void 0 : _ariaDescription4.closeButton;
    $[29] = (_ariaLabel4 = ariaLabel) === null || _ariaLabel4 === void 0 ? void 0 : _ariaLabel4.closeButton;
    $[30] = (_ariaLabelledby4 = ariaLabelledby) === null || _ariaLabelledby4 === void 0 ? void 0 : _ariaLabelledby4.closeButton;
    $[31] = (_dataTestId4 = dataTestId) === null || _dataTestId4 === void 0 ? void 0 : _dataTestId4.closeButton;
    $[32] = (_id4 = id) === null || _id4 === void 0 ? void 0 : _id4.closeButton;
    $[33] = onClose;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== align || $[36] !== anchor || $[37] !== children || $[38] !== initialFocus || $[39] !== side || $[40] !== sideOffset || $[41] !== t10 || $[42] !== t11 || $[43] !== t12 || $[44] !== t13 || $[45] !== t14 || $[46] !== t6 || $[47] !== t7 || $[48] !== t8 || $[49] !== t9) {
    t15 = /*#__PURE__*/_jsxs(PopoverContent, {
      id: t6,
      "aria-label": t7,
      "aria-labelledby": t8,
      "aria-describedby": t9,
      "aria-description": t10,
      "data-test-id": t11,
      side: side,
      align: align,
      sideOffset: sideOffset,
      initialFocus: initialFocus,
      anchor: anchor,
      children: [t12, t13, children, t14]
    });
    $[35] = align;
    $[36] = anchor;
    $[37] = children;
    $[38] = initialFocus;
    $[39] = side;
    $[40] = sideOffset;
    $[41] = t10;
    $[42] = t11;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
    $[46] = t6;
    $[47] = t7;
    $[48] = t8;
    $[49] = t9;
    $[50] = t15;
  } else {
    t15 = $[50];
  }
  let t16;
  if ($[51] !== T0 || $[52] !== t1 || $[53] !== t15 || $[54] !== t2 || $[55] !== t3 || $[56] !== t4 || $[57] !== t5) {
    t16 = /*#__PURE__*/_jsxs(T0, {
      defaultOpen: t1,
      handle: t2,
      onOpenChange: t3,
      open: t4,
      children: [t5, t15]
    });
    $[51] = T0;
    $[52] = t1;
    $[53] = t15;
    $[54] = t2;
    $[55] = t3;
    $[56] = t4;
    $[57] = t5;
    $[58] = t16;
  } else {
    t16 = $[58];
  }
  return t16;
}
PopoverInner.displayName = 'PopoverInner';

/**
 * Config-layer wrapper for `Popover`. Accepts a `trigger` element plus flat
 * `title`, `description`, and `children` content props, and an `onClose`
 * callback that renders a managed close button, instead of composing
 * `PopoverTrigger`, `PopoverContent`, `PopoverTitle`, `PopoverDescription`,
 * and `PopoverClose` by hand.
 *
 * This component is part of Trellis's config API layer and covers the majority
 * of use cases. For advanced patterns, use the compositive API directly. If you
 * find yourself doing so, share your use case in #trellis-support — it directly
 * informs how we evolve the config layer.
 *
 * @see {@link PopoverRoot | Popover}
 */
export const Popover = /*#__PURE__*/forwardRef(PopoverInner);
Popover.displayName = 'Popover';